import * as React from "react";
const SvgDoneCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 19, height: 15, viewBox: "0 0 19 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18 1L6 13L1 8", stroke: "#27AE60", strokeWidth: 2, strokeMiterlimit: 10 }));
export default SvgDoneCheck;
